import React, { useState } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import './MobileNavbar.css'; // Include CSS file for styling
import { useNavigate } from "react-router-dom"
import { useAuth } from "../signin/authcontext.jsx"
import { signOut } from "firebase/auth";
import { auth } from '../../firebase.js';  // Import the auth reference

function MobileNavbar({ WebPages }) {
    const [isOpen, setIsOpen] = useState(false);
    const nav = useNavigate()
    const { user } = useAuth();
    const handleSignOut = async () => {
        try {
          await signOut(auth);
    
          window.location.href = "/login";
        } catch (error) {
          console.error("Error signing out: ", error);
        }
      };
    const navButtonClass = "bg-transparent border-0 cursor-pointer text-left rounded-lg mr-10 p-2 text-xl delay-7 text-white hover:text-red-800 hover:bg-white"
    const WebPagesItems = WebPages.map((pagetitle) => (
        <button
            type="button"
            key={pagetitle[1]}
            className={navButtonClass}
            onClick={() => nav(pagetitle[1])}
        >
            {pagetitle[0]}
        </button>
    ));
    if(user){
        WebPagesItems.push(<button
            type="button"
            key="dashboard"
            className={navButtonClass}
            onClick={() => nav("/dashboard")}
        >
            Dashboard
        </button>
        )
        WebPagesItems.push(<button
            type="button"
            key="sign-out"
            className={navButtonClass}
            onClick={() => handleSignOut()}
        >
           Sign Out
        </button>)
    }
    const onClick = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="fixed top-0 left-0 w-full z-50 ">
            <div className="bg-red-500 p-4 pl-5 shadow-md w-full flex justify-between items-center min-h-24">
                <div className="flex flex-row items-center">
                    <p className="text-white  pr-5">Vihas Veggalam</p>
                    <p className="text-white hidden sm:block text-sm">Programming and Engineering Enthusiast</p>
                </div>
                <div className="relative">
                    <div
                        className={`hamburger-menu ${isOpen ? 'open' : ''}`}
                        onClick={onClick}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="absolute  left-0 w-full bg-red-500 p-4 shadow-md"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                    >
                        <div className="flex flex-col ">
                            {WebPagesItems}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default MobileNavbar;
